import React from "react";
import { useInView } from "react-intersection-observer";

const WhyUs = () => {
  const points = [
    {
      num: "01",
      title: "Specialists, Not Generalists",
      desc: "Each of our services is led by a dedicated domain specialist with a proven track record. You receive deep, focused expertise - not generalist effort spread across too many disciplines.",
    },
    {
      num: "02",
      title: "Outcomes Over Outputs",
      desc: "We measure our success by your business results - increased revenue, qualified leads, and operational efficiency. We don't consider a project complete until it is working for your business.",
    },
    {
      num: "03",
      title: "Africa-Rooted, World-Class",
      desc: "We understand the South African business environment - its pace, its challenges, and its opportunities - and we apply internationally recognised standards to address them. Local insight and global execution, combined.",
    },
    {
      num: "04",
      title: "Full-Cycle Thinking",
      desc: "From building your platform to driving traffic, analysing performance, and assuring quality - we cover the full digital lifecycle. One partner, full accountability, no gaps.",
    },
    {
      num: "05",
      title: "Guaranteed Transparency",
      desc: "Fixed-price scoping, regular progress reporting, and direct access to the team working on your project. You will always know exactly where things stand — no ambiguity, no surprises.",
    },
    {
      num: "06",
      title: "Deliberate Focus",
      desc: "We maintain a focused, senior team by design — ensuring every client receives our best thinking and undivided attention. Sharper communication, deeper engagement, and consistently exceptional work.",
    },
  ];

  const { ref: headerRef, inView: headerInView } = useInView({
    threshold: 0.2,
    triggerOnce: true,
  });
  const { ref: gridRef, inView: gridInView } = useInView({
    threshold: 0.1,
    triggerOnce: true,
  });

  return (
    <section id="why">
      <div
        className={`section-tag ${headerInView ? "visible" : ""}`}
        ref={headerRef}
      >
        <span
          className="section-tag-icon"
          style={{ background: "var(--orange)" }}
        ></span>{" "}
        Why Gauweng
      </div>
      <h2 className={`section-title ${headerInView ? "visible" : ""}`}>
        The <em style={{ color: "var(--accent)" }}>Gauweng</em> Difference
      </h2>

      <div className={`why-grid ${gridInView ? "visible" : ""}`} ref={gridRef}>
        {points.map((p) => (
          <div key={p.num} className="why-card">
            <div className="why-number">{p.num} ◆</div>
            <div className="why-title">{p.title}</div>
            <div className="why-body">{p.desc}</div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default WhyUs;
